module.exports = __webpack_public_path__ + "titre-mémoire.gif?b7caa3fbee1823206d41edeb61d79e18";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/titre-mémoire.gif
// module id = 142
// module chunks = 0